import { FieldErrors, FieldValues } from 'react-hook-form';

/** Returns the first nested react-hook-form / Zod error message. */
export const formatFirstFormError = <T extends FieldValues>(
  errors: FieldErrors<T>,
): string | undefined => {
  const walk = (value: unknown): string | undefined => {
    if (value == null || typeof value !== 'object') return undefined;

    if (
      'message' in value &&
      typeof (value as { message?: unknown }).message === 'string'
    ) {
      return (value as { message: string }).message;
    }

    for (const nested of Object.values(value)) {
      const message = walk(nested);
      if (message) return message;
    }

    return undefined;
  };

  return walk(errors);
};
